// extracted by mini-css-extract-plugin
export default {"secondaryHeader":"SecondaryHeader_secondaryHeader__M7jgY"};